var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * @param {Array<DepositRate>} rates
 * @param {DepositInput} input
 * @return number
 */
export function getRate(rates, input) {
    var resultRates;
    resultRates = getRatesByCurrency(rates, input.currency);
    termIntervalConversion(resultRates);
    resultRates = getRatesByAmount(resultRates, input.amount);
    resultRates = getRatesByTerm(resultRates, input.term);
    if (resultRates.length !== 1) {
        throw 'Rate not found';
    }
    return resultRates[0];
}
/**
 * @param {Array<DepositRate>} rates
 */
export function termIntervalConversion(rates) {
    var uniqueTerms = __spread(new Set(rates.map(function (rate) { return rate.term_min; }))).sort(function (a, b) { return a - b; });
    for (var i = 0; i < rates.length; i++) {
        var index = uniqueTerms.indexOf(rates[i].term_min);
        if (index === 0) {
            rates[i].term_min = 0;
        }
        if (rates[i].term_min === rates[i].term_max) {
            if (index > 0) {
                rates[i].term_min = uniqueTerms[index - 1] + 1;
            }
        }
    }
}
/**
 * @param {Array<DepositRate>} rates
 * @param {string} currency
 * @return Array<DepositRate>
 */
export function getRatesByCurrency(rates, currency) {
    return rates.filter(function (rate) { return rate.currency === currency; });
}
/**
 * @param {Array<DepositRate>} rates
 * @param {number} amount
 * @return Array<DepositRate>
 */
export function getRatesByAmount(rates, amount) {
    var amountMax = Math.max.apply(Math, __spread(rates.map(function (rate) { return Number(rate.sum_max); })));
    return rates
        .sort(function (current, next) { return sortNumberAsc(current, next, 'sum_min'); })
        .filter(function (rate) {
        if (rate.sum_max !== null) {
            if (rate.sum_max === amountMax && amount > amountMax) {
                return true;
            }
            return rate.sum_min <= amount && amount <= rate.sum_max;
        }
        else {
            return rate.sum_min <= amount;
        }
    });
}
/**
 * @param {Array<DepositRate>} rates
 * @param {number} term
 * @return Array<DepositRate>
 */
export function getRatesByTerm(rates, term) {
    return rates
        .sort(function (current, next) { return sortNumberAsc(current, next, 'term_min'); })
        .filter(function (rate, index, rates) {
        if (rates[rates.length - 1].term_min === rate.term_min) {
            return term >= rate.term_min;
        }
        return term >= rate.term_min && term <= rate.term_max;
    });
}
/**
 * @param {DepositRate} currentRate
 * @param {DepositRate} nextRate
 * @param {string} field
 * @return number
 */
function sortNumberAsc(currentRate, nextRate, field) {
    var current = Number(currentRate[field]);
    var next = Number(nextRate[field]);
    if (current > next) {
        return 1;
    }
    if (current < next) {
        return -1;
    }
    return 0;
}
